import script from "./WorkflowAggregatesCodeViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAggregatesCodeViewer.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAggregatesCodeViewer.vue?vue&type=style&index=0&id=7a6d20a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6d20a4"]])

export default __exports__